import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert } from "lucide-react";
import { licenseTier, licenseSummary, TIER_STYLES } from "@/lib/license";

export const LicenseBadge = ({ expiry, testId }) => {
  const t = licenseTier(expiry);
  if (!t) return null;
  return (
    <span className={`pill border ${TIER_STYLES[t.tier]}`} data-testid={testId} data-tier={t.tier}>
      <AlertTriangle className="w-3 h-3" /> {t.days < 0 ? "License expired" : t.days <= 1 ? (t.days === 0 ? "Expires today" : "Expires tomorrow") : `Expires in ${t.days}d`}
    </span>
  );
};

const PARTS = [
  ["urgent", (n) => `${n} expired or expiring within a day`],
  ["warning", (n) => `${n} expiring within 7 days`],
  ["notice", (n) => `${n} expiring within 30 days`],
];

// Summary line for the Drivers page and dashboard; colour follows the most urgent tier.
export const LicenseAlerts = ({ drivers, link = false, className = "" }) => {
  const s = licenseSummary(drivers);
  const top = PARTS.find(([k]) => s[k] > 0)?.[0];
  if (!top) return null;
  const total = s.urgent + s.warning + s.notice;
  const body = (
    <div className={`flex items-start gap-2.5 rounded-xl border px-4 py-3 text-sm ${TIER_STYLES[top]} ${className}`} data-testid="license-alerts" data-tier={top}>
      <ShieldAlert className="w-5 h-5 shrink-0" />
      <div>
        <span className="font-semibold">{total} driver license{total === 1 ? "" : "s"} need{total === 1 ? "s" : ""} attention</span>
        <span className="block sm:inline sm:ml-2">
          {PARTS.filter(([k]) => s[k] > 0).map(([k, f]) => <span key={k} className="mr-3" data-testid={`license-alerts-${k}`}>{f(s[k])}</span>)}
        </span>
      </div>
    </div>
  );
  return link ? <Link to="/admin/drivers" className="block hover:opacity-90" data-testid="license-alerts-link">{body}</Link> : body;
};
